const icons = {};

icons.unlocked = (
	<svg className="dashicon" width="14px" height="14px" viewBox="0 0 14 14">
		<path d="m3.25 6q-0.312 0-0.531 0.219t-0.219 0.531v4.5q0 0.312 0.219 0.531t0.531 0.219h7.5q0.312 0 0.531-0.219t0.219-0.531v-4.5q0-0.312-0.219-0.531t-0.531-0.219h-0.25v-2.5q0-1.445-1.027-2.473-1.028-1.027-2.473-1.027t-2.473 1.027q-1.027 1.028-1.027 2.473 0 0.203 0.148 0.352 0.149 0.148 0.352 0.148h0.5q0.203 0 0.352-0.148 0.148-0.149 0.148-0.352 0-0.828 0.586-1.414t1.414-0.586 1.414 0.586 0.586 1.414v2.5h-5.75z" />
	</svg>
);

export default icons;
